import { BaseModel } from './base.model';

export class TagModel extends BaseModel {
  id: string;
  name: string;
  cssClass: string;
  projectId: string;
}
